import { create } from 'zustand';

/**
 * Ungespeicherte Eingaben im Ticket-Cockpit (angefangener Kommentar, Zeiteintrag, …).
 *
 * Formulare registrieren sich hier, solange sie Inhalt tragen. Der Cockpit-Drawer
 * fragt beim Schließen (Escape, Klick daneben, X) nach, statt die Eingabe stumm zu
 * verwerfen — genau das hat vorher angefangene Kommentare gekostet.
 */
interface UnsavedDraftsState {
  /** key (z. B. "comment:<ticketId>") → Label für die Rückfrage (z. B. "angefangener Kommentar"). */
  drafts: Record<string, string>;
  setDraft: (key: string, label: string | null) => void;
}

export const useUnsavedDrafts = create<UnsavedDraftsState>((set) => ({
  drafts: {},
  setDraft: (key, label) =>
    set((s) => {
      if (label ? s.drafts[key] === label : !(key in s.drafts)) return s;
      const drafts = { ...s.drafts };
      if (label) drafts[key] = label;
      else delete drafts[key];
      return { drafts };
    }),
}));
